<template>
  <p :class="$abem({ block: 'a-completedMessage' })">
    {{ $t("Your submission was successful.") }}
  </p>
</template>

<script>
export default {
  mounted () {
    this.$reflowIframe()

    const iframe = window.parent.document.querySelector('iframe')
    if (iframe) {
      // Re-orient the parent window to the top of the iframe with slight offset.
      window.parent.scrollTo(0, iframe.getBoundingClientRect().x - 100)
    }
  }
}
</script>

<style lang="scss">
.a-completedMessage {
  background-color: #9abf4c;
  color: white;
  padding: 1rem;
  font-size: 1rem;
}
</style>
